import type { PendingAuthAction } from "./pendingAction";
import { toRelativeAppPath } from "./kakaoOidc";

export type EmailAuthMode = "sign-in" | "sign-up";

export function getEmailAuthModeForAction(action?: PendingAuthAction | null): EmailAuthMode {
  return action && action.type !== "redirect" ? "sign-up" : "sign-in";
}

export function buildEmailAuthPath(next?: string | null, mode: EmailAuthMode = "sign-in") {
  const params = new URLSearchParams({
    mode,
    next: toRelativeAppPath(next || "/app"),
  });

  return `/auth/email?${params.toString()}`;
}

export function buildEmailVerificationRedirectUrl(params: {
  origin: string;
  next?: string | null;
}) {
  const searchParams = new URLSearchParams({
    mode: "sign-in",
    verified: "1",
    next: toRelativeAppPath(params.next || "/app"),
  });

  return new URL(`/auth/email?${searchParams.toString()}`, params.origin).toString();
}
